import { c as _c } from "react/compiler-runtime";
import { cva } from 'class-variance-authority';
import Button from '../../button';
import LinkButton from '../../link-button';
import type { DialogFooter } from '../dialog.types';
const footerVariants = cva('flex flex-col flex-0 box-border md:flex-row-reverse items-center justify-between w-full bg-primary relative', {
  variants: {
    size: {
      'full-screen': 'md:px-4 px-1 py-2',
      default: 'py-3 md:py-4 md:px-6 px-3'
    }
  }
});
const buttonContainerVariants = cva('flex gap-2 w-full', {
  variants: {
    layout: {
      'full-screen': 'flex-row justify-between',
      'full-screen-single-button': 'flex-row justify-end',
      'full-screen-with-link': 'flex-row justify-end',
      default: 'flex-col-reverse md:flex-row md:justify-end'
    }
  }
});
const Footer = t0 => {
  const $ = _c(33);
  const {
    linkButton,
    primaryButton,
    secondaryButton,
    size,
    hasScroll
  } = t0;
  const hasBorder = size === "full-screen" || hasScroll;
  const isFullScreen = size === "full-screen";
  let t1;
  if ($[0] !== isFullScreen || $[1] !== linkButton || $[2] !== primaryButton || $[3] !== secondaryButton) {
    t1 = () => {
      if (!isFullScreen) {
        return "default";
      }
      if (primaryButton && secondaryButton && !linkButton) {
        return "full-screen";
      }
      if (linkButton) {
        return "full-screen-with-link";
      }
      return "full-screen-single-button";
    };
    $[0] = isFullScreen;
    $[1] = linkButton;
    $[2] = primaryButton;
    $[3] = secondaryButton;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const getLayout = t1;
  const t2 = isFullScreen ? "full-screen" : "default";
  let t3;
  if ($[5] !== t2) {
    t3 = footerVariants({
      size: t2
    });
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `${t3}`;
  const t5 = hasBorder ? "var(--border-color-tertiary)" : "transparent";
  let t6;
  if ($[7] !== t5) {
    t6 = {
      borderColor: t5,
      borderStyle: "solid",
      borderWidth: "1px",
      borderPosition: "top"
    };
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = t6 as React.CSSProperties;
  let t8;
  if ($[9] !== isFullScreen || $[10] !== linkButton) {
    t8 = isFullScreen && linkButton && <div className="flex"><LinkButton destructive={linkButton.destructive} disabled={linkButton.disabled} form={linkButton.form} onClick={linkButton.onClick} type={linkButton.type} iconComponent={linkButton.iconComponent} iconPosition={linkButton.iconPosition}>{linkButton.label}</LinkButton></div>;
    $[9] = isFullScreen;
    $[10] = linkButton;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== getLayout) {
    t9 = buttonContainerVariants({
      layout: getLayout()
    });
    $[12] = getLayout;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== secondaryButton) {
    t10 = secondaryButton && <Button id={secondaryButton.id} disabled={secondaryButton.disabled} form={secondaryButton.form} loading={secondaryButton.loading} loadingAriaLabel={secondaryButton.loadingAriaLabel} onClick={secondaryButton.onClick} type={secondaryButton.type} variant={secondaryButton.variant || "secondary"}>{secondaryButton.label}</Button>;
    $[14] = secondaryButton;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== primaryButton) {
    t11 = primaryButton && <Button id={primaryButton.id} disabled={primaryButton.disabled} form={primaryButton.form} loading={primaryButton.loading} loadingAriaLabel={primaryButton.loadingAriaLabel} onClick={primaryButton.onClick} type={primaryButton.type} variant={primaryButton.variant || "primary"}>{primaryButton.label}</Button>;
    $[16] = primaryButton;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t9) {
    t12 = <div className={t9}>{t10}{t11}</div>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t8) {
    t13 = <div className="flex w-full items-center">{t8}{t12}</div>;
    $[22] = t12;
    $[23] = t8;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== isFullScreen || $[26] !== linkButton) {
    t14 = !isFullScreen && linkButton && <div className="flex p-3 md:p-0"><LinkButton destructive={linkButton.destructive} disabled={linkButton.disabled} form={linkButton.form} onClick={linkButton.onClick} type={linkButton.type} iconComponent={linkButton.iconComponent} iconPosition={linkButton.iconPosition}>{linkButton.label}</LinkButton></div>;
    $[25] = isFullScreen;
    $[26] = linkButton;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13 || $[29] !== t14 || $[30] !== t4 || $[31] !== t7) {
    t15 = <footer className={t4} style={t7}>{t13}{t14}</footer>;
    $[28] = t13;
    $[29] = t14;
    $[30] = t4;
    $[31] = t7;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
};
export default Footer;